import type { MinimalStepRuleModel } from '@/shared/generated'
import type { JSONSchemaType } from 'ajv/dist/core'

import { Controller, useFormContext } from 'react-hook-form'

import { ErrorBoundary } from '@/shared/components/ErrorBoundary'

import { MinimalPriceStepFileds } from './MinimalPriceStepFileds'

export function MinimalPriceStepFiledController({
	name,
	shouldUnregister,
	defaultValue,
	schema,
}: {
	name: string
	shouldUnregister?: boolean
	defaultValue?: MinimalStepRuleModel[]
	schema: JSONSchemaType<MinimalStepRuleModel[]>
}) {
	const { control } = useFormContext()

	return (
		<Controller
			name={name}
			control={control}
			shouldUnregister={shouldUnregister}
			defaultValue={defaultValue}
			render={({ field: { value, onChange } }) => (
				<ErrorBoundary>
					<MinimalPriceStepFileds
						formData={value}
						onChange={onChange}
						schema={schema}
					/>
				</ErrorBoundary>
			)}
		/>
	)
}
